import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { BBInvitations, BBInvitationsDefaultValues } from 'src/app/components/invitations/bb-invitations/bb-invitation';
import { BbInvitationFormComponent } from 'src/app/components/invitations/bb-invitations/bb-invitation-form/bb-invitation-form.component';
import { BbInvitationService } from 'src/app/services/bb-invitation.service';
import { ToastService } from 'src/app/services/toast-service.service';

@Component({
    selector: 'app-create-invite-bb',
    templateUrl: './create-invite-bb.component.html',
    styleUrls: ['./create-invite-bb.component.scss'],
    standalone: false
})
export class CreateInviteBbComponent {

  bbinvitation: BBInvitations = BBInvitationsDefaultValues();
  @ViewChild(BbInvitationFormComponent) bbinvitationForm!:BbInvitationFormComponent;
  isSubmitted=false;
  pageName = CheckPageAccess.ADDBBINVITATION
  constructor(private _bbinviteservice: BbInvitationService, private _toastservice: ToastService, private router: Router) { }

  onSubmit() {
    this.isSubmitted=true;
    if(!this.bbinvitationForm.validateReqFileds())
    {
      this._toastservice.showErrorMessage('Please correct all the errors first.')
      return;
    }
    this._bbinviteservice.createbbinvitation(this.bbinvitation).subscribe({
      next: (response) => {
        if (response.status) {
          this._toastservice.showMessage(response.message);
          this.router.navigateByUrl("/bb-invite-list");
        }
        else {
          this._toastservice.showErrorMessage(response.message)
        }
      }
    })
  }

 
  
}
